import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'

const columns: GridColDefVNW<any>[] = [
    {
        field: 'product_group_name',
        headerName: 'product_group_name',
        width: 400,
    },
    {
        field: 'employee_name',
        headerName: 'employee_name',
        width: 300,
    },
    {
        field: 'rate_of_newsale',
        headerName: 'kpi.employee.rate_of_newsale',
        width: 150,
    },
    {
        field: 'rate_of_upsale',
        headerName: 'kpi.employee.rate_of_upsale',
        width: 150,
    },
    {
        field: 'rate_of_renewal',
        headerName: 'kpi.employee.rate_of_renewal',
        width: 150,
    },
]

export default columns
